module.exports = __webpack_public_path__ + "img/conductor.aa2b5713.png";